/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Environment } from "./Environment";
export const EnvironmentResponse = core.serialization.object({
    data: Environment,
});
